const getContactDisplayName = (contact) => {
  if (!contact) {
    return "";
  }

  const name = contact.name || "";
  const nickname = contact.nickname?.trim();

  if (nickname) {
    return `${name} (${nickname})`;
  }

  return name;
};

export default getContactDisplayName;